module.exports = __webpack_public_path__ + "img/mobile.5b2c6474.svg";